import { CaretDown, CaretRight } from '@liveauctioneers/hammer-ui-core/icons';
import { Collapse } from 'react-collapse';
import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import { QueryParams, SetActiveIdCallback } from '@/pages/Notifications/notifications.types';
import { ReactNode } from 'react';
import styled, { useTheme } from 'styled-components';
import TableRow from './TableRow';
import Text from '@liveauctioneers/caterwaul-components/lib/Text/Text';
import useWindowSize from '@/hooks/useWindowSize';

type Props = {
    activeId: QueryParams['section'];
    browser?: ReactNode;
    component: ReactNode;
    count: number;
    email?: ReactNode;
    id: QueryParams['section'];
    setActiveId: SetActiveIdCallback;
    sms?: ReactNode;
};

const Section = ({ activeId, browser, component, count, email, id, setActiveId, sms }: Props) => {
    const { width } = useWindowSize();
    const {
        breakpoints: { tabletNarrowWidthNum },
    } = useTheme();

    const open = activeId === id;

    return (
        <>
            <SectionContainer onClick={() => setActiveId(open ? '' : id)}>
                <TableRow
                    browser={browser}
                    email={email}
                    sms={sms}
                    type={
                        <CenteredTitle>
                            <IconContainerSpan>
                                {open ? (
                                    <CaretDown
                                        size="xs"
                                        style="fill"
                                    />
                                ) : (
                                    <CaretRight
                                        size="xs"
                                        style="fill"
                                    />
                                )}
                            </IconContainerSpan>
                            <Text
                                h3={width > tabletNarrowWidthNum}
                                h4={width <= tabletNarrowWidthNum}
                                testid="sectionOption"
                            >
                                <FormattedMessage
                                    id={`notificationsPage.section.${id}`}
                                    values={{ count }}
                                />
                            </Text>
                        </CenteredTitle>
                    }
                />
            </SectionContainer>
            <Collapse isOpened={open}>
                <div>{component}</div>
            </Collapse>
        </>
    );
};

export default Section;

const SectionContainer = styled.div`
    cursor: pointer;
    height: 84px;
    align-items: center;
    h3 {
        margin: auto 0;
    }
`;

const CenteredTitle = styled.div`
    height: 52px;
    display: flex;
    align-items: center;
`;

const IconContainerSpan = styled.span`
    width: 16px;
    height: 16px;
    display: block;
    margin-right: 4px;
`;
